import Details from "./Details";
import React from "react";
import {useTranslation} from "react-i18next";

export default function Withdraw({handleClose, money, coins}) {

  const [check, setCheck] = React.useState(false);
  const HandleCheckBox = () => {
    setCheck(!check);
  };
  const {t} = useTranslation()

  return (
    <>
      <div className="scroll-body">
        <div className="withdraw-container">
          <div className="right-side">
            <p>{t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.WithdrawalApplication.Label')}</p>
            <div className="ri-select">
              <label>
                {t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.CardNumberOrShaba.Place.Holder')}
              </label>
              <select>
                <option>1</option>
                <option>2</option>
              </select>
            </div>
            <div className="ri-input">
              <label>{t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Amount.Place.Holder')}</label>
              <input type="text"/>

            </div>
            <div className="ri-btn">
              <button className="btn-st-1">
                {t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Withdraw.Button')}
              </button>
              <button onClick={handleClose} className="btn-st-2">
                {t('Organizational.PointsManagment.PointsAllocation.WalletRecharge.Cancel.Button')}
              </button>
            </div>
          </div>
          <div className="left-side">
            <Details money={money} coins={coins}/>
          </div>
        </div>
      </div>
    </>
  )
}
